import type { IUpdateLocationDesignCmd } from "@/data/commands/location/UpdateLocationDesignCmd";
import { Factory } from "@/data/dao/Factory";
import { LocationDao } from "@/data/dao/service/LocationDao";
import type { IDesign, ILocationDetail } from "@/data/model/Location";

import { type VueComponentInstance, createVueComponent } from "@/shared/utils/vue";

import ScreenSaverImagesEditor from "@/portal/components/location/ScreenSaverImagesEditor.vue";
import { ColorPicker } from "@/portal/formControls/ColorPicker";
import { ImagePicker } from "@/portal/formControls/ImagePicker";
import { BaseEntityForm } from "@/portal/forms/BaseEntityForm";

export class LocationDesignForm extends BaseEntityForm<ILocationDetail, IUpdateLocationDesignCmd> {
    private logoDarkPicker: ImagePicker<IDesign>;
    private logoLightPicker: ImagePicker<IDesign>;
    private colorPicker: ColorPicker;
    private colorPrimaryPicker: ColorPicker;
    private screenSaverImages: VueComponentInstance<typeof ScreenSaverImagesEditor>;

    constructor(element: JQuery) {
        super(element, {
            getSingle: undefined as any,
            create: undefined as any,
            getData: undefined as any,
            remove: undefined as any,
            update: (i, d) => Factory.getInstance<LocationDao>(LocationDao).setDesign(i, d),
        });

        this.logoDarkPicker = new ImagePicker<IDesign>({
            create: undefined as any,
            remove: undefined as any,
            valueAccessor: (m, setter) => {
                if (setter !== undefined) m.logoDarkPath = setter == null ? undefined : setter;

                return m.logoDarkPath;
            },
        }).renderTo(this.$form.find("#darklogoimage"));

        this.logoLightPicker = new ImagePicker<IDesign>({
            create: undefined as any,
            remove: undefined as any,
            valueAccessor: (m, setter) => {
                if (setter !== undefined) m.logoLightPath = setter == null ? undefined : setter;

                return m.logoLightPath;
            },
        }).renderTo(this.$form.find("#lightlogoimage"));

        this.colorPicker = ColorPicker.createFromFormCtrl(this.$form.find('input[name="color"]'));
        this.colorPrimaryPicker = ColorPicker.createFromFormCtrl(this.$form.find('input[name="colorprimary"]'));

        this.screenSaverImages = createVueComponent(
            ScreenSaverImagesEditor,
            {},
            this.$form.find("#screensaverimages")[0]
        ).mountedComponent;
    }

    public setFormData(model?: ILocationDetail) {
        this.logoDarkPicker.setValue(model === undefined ? undefined : model.design);
        this.logoLightPicker.setValue(model === undefined ? undefined : model.design);
        this.colorPicker.setValue(model === undefined ? undefined : model.design.color);
        this.colorPrimaryPicker.setValue(model === undefined ? undefined : model.design.colorPrimary);
        this.screenSaverImages.setLocation(model?.id);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getFormData($form: JQuery): IUpdateLocationDesignCmd {
        const data: IUpdateLocationDesignCmd = {
            logoDark: this.logoDarkPicker.hasPendingDelete === false ? this.logoDarkPicker.pendingFile : undefined,
            logoLight: this.logoLightPicker.hasPendingDelete === false ? this.logoLightPicker.pendingFile : undefined,
            deleteDarkLogo: this.logoDarkPicker.hasPendingDelete,
            deleteLightLogo: this.logoLightPicker.hasPendingDelete,
            color: this.colorPicker.getValue(),
            colorPrimary: this.colorPrimaryPicker.getValue(),
        };

        return data;
    }
}
